import { Component, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { Image } from "../../shared/image-uploader/image.interface";
import { ImageService } from "../../shared/image-uploader/image.service";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";

@Component({
  selector: "app-custom-icon-add",
  templateUrl: "./custom-icon-add.component.html",
  styleUrls: ["./custom-icon-add.component.scss"],
  standalone: false,
})
export class CustomIconAddComponent implements OnInit {
  file;
  public form: UntypedFormGroup;
  public errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();
  private readonly MAX_PREVIEW_WIDTH = 100;

  constructor(
    public imageService: ImageService,
    private dialogRef: MatDialogRef<CustomIconAddComponent>,
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    this.form = new UntypedFormGroup({
      file: new UntypedFormControl("", (control) =>
        Validators.required(control),
      ),
      name: new UntypedFormControl("", (control) =>
        Validators.required(control),
      ),
      url: new UntypedFormControl("", (control) =>
        Validators.required(control),
      ),
      imageWidth: new UntypedFormControl("", (control) =>
        Validators.min(0)(control),
      ),
      imageHeight: new UntypedFormControl("", (control) =>
        Validators.min(0)(control),
      ),
      originalImageWidth: new UntypedFormControl("", (control) =>
        Validators.min(0)(control),
      ),
      originalImageHeight: new UntypedFormControl("", (control) =>
        Validators.min(0)(control),
      ),
    });
  };

  onSubmit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid) {
      return;
    }
    const formValue = this.form.value as {
      name: string;
      originalImageWidth: number;
      originalImageHeight: number;
    };
    const formData: {
      name: string;
      originalImageWidth: number;
      originalImageHeight: number;
      file: File;
      alt: string;
    } = {
      ...formValue,
      file: this.file as File,
      alt: formValue.name,
    };
    this.dialogRef.close(formData);
  };

  fileChange = (file: Image) => {
    this.file = file.file;
    const formValue = this.form.value as {
      originalImageWidth: number;
      originalImageHeight: number;
    };
    const originalWidth = file.width || formValue.originalImageWidth;
    const originalHeight = file.height || formValue.originalImageHeight;

    const previewWidth = Math.min(originalWidth, this.MAX_PREVIEW_WIDTH);
    const previewHeight =
      originalWidth > 0 ? (previewWidth / originalWidth) * originalHeight : 0;

    this.form.patchValue({
      file: file.file,
      originalImageWidth: originalWidth,
      originalImageHeight: originalHeight,
      imageWidth: previewWidth,
      imageHeight: previewHeight,
    });
  };

  removeFile = () => {
    this.file = null;
    this.form.patchValue({
      file: "",
      imageWidth: "",
      imageHeight: "",
      originalImageWidth: "",
      originalImageHeight: "",
    });
  };

  cancel = () => {
    this.fillInitialForm();
    this.dialogRef.close();
  };
}
